import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { AuthService } from '../user/auth.service';


@Injectable()
export class CommonService {

  selectedLanguage: string;

  constructor(private authService: AuthService,
              private dateTransform: DatePipe
  ) {
    this.selectedLanguage = this.authService.sessionHelper.selectedLanguage;
  }

  formatDate(date: Date): string {
    return (date && date != null) ? this.dateTransform.transform(date, 'dd/MM/yyyy') : null;
  }

  customDateFormat(date: any) {
    console.log('passo di qui (1)', date);
    let day;
      let month;
      let year;
    if (this.selectedLanguage === 'it') {
      let newdate;
      if (typeof date === 'string' &&  date.indexOf('/') !== -1) {
        newdate = date.split('/');
        return newdate[0] + '/' + newdate[1] + '/' + newdate[2];
      } else {
        if (typeof date === 'string') {
          newdate = date.split('-');
          return newdate[2] + '/' + newdate[1] + '/' + newdate[0];
        }
        day = '' + date.getDate();
        month = '' + (date.getMonth() + 1);
        year = date.getFullYear();
        if (month.length < 2) {
          month = '0' + month;
        }
        if (day.length < 2) {
          day = '0' + day;
        }
        return day + '/' + month + '/' + year;
      }
    }else {
      let d = /*(typeof date == "date") ? date :*/ new Date(date);
      day = '' + d.getDate();
      month = '' + (d.getMonth() + 1);
      year = d.getFullYear();
      if (month.length < 2) {
        month = '0' + month;
      }
      if (day.length < 2) {
        day = '0' + day;
      }
      return day + '/' + month + '/' + year;
    }

  }

  customDateFormatBasedOnLanguage(date: any) {
    let d = new Date(date);
    let day = '' + d.getDate();
    let month = '' + (d.getMonth() + 1);
    let year = d.getFullYear();
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    if (this.selectedLanguage === 'it') {
      return day + '/' + month + '/' + year;
    }else {
      return month + '/' + day + '/' + year;
    }
  }

  numberFormatter(num, digits) {
    console.log(num);
    num = parseFloat(num);
    let si = [
      { value: 1E18, symbol: 'E' },
      { value: 1E15, symbol: 'P' },
      { value: 1E12, symbol: 'T' },
      { value: 1E9, symbol: 'B' },
      { value: 1E6, symbol: 'M' },
      { value: 1E3, symbol: 'K' }
    ], rx = /\.0+$|(\.[0-9]*[1-9])0+$/, i;
    for (i = 0; i < si.length; i++) {
      if (num >= si[i].value) {
        if (this.selectedLanguage === 'it') {
          return (num / si[i].value).toFixed(digits).replace(rx, '$1').replace('.', ',') + si[i].symbol;
        }else {
          return (num / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol;
        }
      }
    }
      if (this.selectedLanguage === 'it') {
        return num.toFixed(digits).replace(rx, '$1').replace('.', ',');
      }else {
        return num.toFixed(digits).replace(rx, '$1');
      }
  }

  fromDateToDBString(date: Date) {
    let res = '';
    if (date) {
      let year = date.getFullYear().toString();
      let month = (date.getMonth() + 1).toString();
      let day = date.getDate().toString();

      if (month.length < 2) {
        month = '0' + month;
      }
      if (day.length < 2) {
        day = '0' + day;
      }
      res = year + '-' + month + '-' + day;
    }
    return res;
  }
  getCheckdigit(cardNo: string){
    let res = "";
    cardNo.trim();
    
    if(cardNo.length>0){
      
      if(cardNo.length == 12){
        try{          
          let sum = 0;
          for (let index = 0; index < 12; index++) {
            sum = sum + (+cardNo.charAt(index) * (index % 2 == 0 ? 1 : 3));          
          }
          let finalSum = (sum % 10 == 0) ? 0 : (10 - (sum % 10));
          res = finalSum.toString();
        }
        catch(e){
          res = "";
        }        
      }              
    }      
    return res;
  };
  getCardWithCheckdigit(cardNo: string){
    let res = "";
    cardNo.trim();    
    
    if(cardNo.length>0){
      
      if(cardNo.length == 12){
        try{      
          let checkDigit = this.getCheckdigit(cardNo);                
          res = cardNo + checkDigit;
        }
        catch(e){
          res = "";
        }        
      }              
    }      
    return res;
  };
}



// WEBPACK FOOTER //
// ./src/app/services/utils/common.service.ts